const validateDiscoveryProfileEmail = async (axios, encryptedData) => {
  try {
    const res = await axios.get('/snow-allowance', {
      params: {
        encryptedData,
      },
    });
    return { emailValid: true, ...res.data };
  } catch (error) {
    return { emailValid: false };
  }
};

export default validateDiscoveryProfileEmail;
